var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDownUi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 -2 24 24",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0801 6.83003C20.1739 6.73537 20.3017 6.68213 20.4351 6.68213C20.5684 6.68213 20.6962 6.73537 20.7901 6.83003L21.8501 7.89003C21.9467 7.98076 22.0016 8.10744 22.0016 8.24003C22.0016 8.37261 21.9467 8.49929 21.8501 8.59003L12.6601 17.78C12.5195 17.9207 12.3289 17.9999 12.1301 18H11.8701C11.6712 17.9999 11.4806 17.9207 11.3401 17.78L2.15005 8.59003C2.05338 8.49929 1.99854 8.37261 1.99854 8.24003C1.99854 8.10744 2.05338 7.98076 2.15005 7.89003L3.21005 6.83003C3.30394 6.73537 3.43174 6.68213 3.56505 6.68213C3.69837 6.68213 3.82617 6.73537 3.92005 6.83003L12.0001 14.91L20.0801 6.83003Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownUi);
export default __webpack_public_path__ + "static/media/down_ui.e4bef5dd.svg";
export { ForwardRef as ReactComponent };